import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Loader } from "../Loader/Loader";
import { cn } from "@/lib/utils";

export type ConfirmModalProps = {
  isOpen: boolean;
  title: string;
  description: React.ReactNode;
  submitLabel: string;
  submitButtonVariant?:
    | "default"
    | "outline"
    | "ghost"
    | "link"
    | "error"
    | "standout"
    | "primary"
    | null
    | undefined;
  isLoading?: boolean;
  onSubmit: () => void;
  onClose: () => void;
  className?: string;
};

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  title,
  description,
  submitLabel = "Submit",
  submitButtonVariant = "default",
  isLoading = false,
  onSubmit,
  onClose,
  className = ""
}) => {
  return (
    <Dialog
      open={isOpen}
      modal
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <DialogContent
        className={cn("w-full gap-0 bg-background p-0", className)}
        showCloseIcon={false}
        onClose={onClose}
      >
        <DialogHeader className="px-6 pt-6">
          <DialogTitle className="title-h5 mb-2 whitespace-pre-line text-left">{title}</DialogTitle>
        </DialogHeader>
        <div className="subtext-small flex w-full flex-col px-6 text-gray-dark-1000 max-lg:max-w-full">
          {description}
        </div>
        <DialogFooter className="mt-6 flex flex-row !justify-end gap-2 rounded-b-lg border-t border-gray-dark-200 px-6 py-4 dark:border-gray-dark-200 dark:bg-gray-dark-600">
          <Button
            type="button"
            onClick={onClose}
            variant="ghost"
            size="sm"
            data-testid="ConfirmModal_Button"
          >
            Cancel
          </Button>
          <Button
            type="button"
            size="sm"
            disabled={isLoading}
            variant={submitButtonVariant}
            onClick={onSubmit}
            data-testid="ConfirmModal_PrimaryButton"
          >
            {isLoading ? (
              <div className="mr-2">
                <Loader className="!h-[12px] !w-[12px]" color="#000" />
              </div>
            ) : null}
            {submitLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
